import httpClient from './httpClient';
import type {
  InventoryCountItem,
  InventoryCountDetail,
  CreateInventoryCountRequest,
  RecordCountRequest,
  LowStockItem,
  ExchangeRates,
} from '@/types/inventory';
import type { PaginatedResult } from '@/types';

export async function fetchInventoryCounts(
  mdPage: number = 1,
  mdPageSize: number = 20,
): Promise<PaginatedResult<InventoryCountItem>> {
  const mdResponse = await httpClient.get<PaginatedResult<InventoryCountItem>>(
    '/warehouse/inventory-counts',
    { params: { page: mdPage, pageSize: mdPageSize } },
  );
  return mdResponse.data;
}

export async function fetchInventoryCountById(
  mdId: string,
): Promise<InventoryCountDetail> {
  const mdResponse = await httpClient.get<InventoryCountDetail>(
    `/warehouse/inventory-counts/${mdId}`,
  );
  return mdResponse.data;
}

// Сервер повертає Guid створеної інвентаризації
export async function createInventoryCount(
  mdRequest: CreateInventoryCountRequest,
): Promise<string> {
  const mdResponse = await httpClient.post<string>(
    '/warehouse/inventory-counts',
    mdRequest,
  );
  return mdResponse.data;
}

export async function startInventoryCount(mdId: string): Promise<void> {
  await httpClient.post(`/warehouse/inventory-counts/${mdId}/start`);
}

export async function recordCount(
  mdCountId: string,
  mdRequest: RecordCountRequest,
): Promise<void> {
  await httpClient.post(
    `/warehouse/inventory-counts/${mdCountId}/lines/${mdRequest.lineId}/count`,
    { countedQuantity: mdRequest.countedQuantity },
  );
}

export async function completeInventoryCount(mdId: string): Promise<void> {
  await httpClient.post(`/warehouse/inventory-counts/${mdId}/complete`);
}

export async function fetchLowStock(): Promise<LowStockItem[]> {
  const mdResponse = await httpClient.get<LowStockItem[]>(
    '/warehouse/low-stock',
  );
  return mdResponse.data;
}

// Усі курси НБУ на сьогодні: { "USD": 44.618, "EUR": 51.5231, ... }
export async function fetchExchangeRates(): Promise<ExchangeRates> {
  const mdResponse = await httpClient.get<ExchangeRates>('/exchange-rates/all');
  return mdResponse.data;
}
